// Config panel for the "voicemail_call" action block
import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Alert
} from '@mui/material';

const VoicemailCallConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    const mailbox = updated.mailbox || '{{callee}}';
    onSummaryChange(`Voicemail → ${mailbox}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Send the caller directly to a voicemail box without ringing the target.
        The caller will hear the voicemail greeting and can leave a message.
      </Typography>

      <TextField
        size="small"
        label="Mailbox Extension"
        value={config.mailbox || ''}
        onChange={(e) => handleChange('mailbox', e.target.value)}
        placeholder="{{callee}}"
        helperText={'Leave empty to use the original destination\'s mailbox. Supports variables: {{callee}}, {{caller}}'}
      />

      <Alert severity="info" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        The voicemail box must exist in the Asterisk voicemail configuration.
        If it doesn't exist, the caller will hear an error message.
      </Alert>
    </Box>
  );
};

export default VoicemailCallConfig;
